import { registerLibrary as trRegisterLibrary, getLibrary as trGetLibrary, getLibraries as trGetLibraries, } from '@tr/app-information';
/**
 * Register a library into the global record.
 * @public
 * @remarks It will fail if the same library is register twice.
 * @param library - Library information
 */
export function registerLibrary(library) {
    trRegisterLibrary(library);
}
/**
 * Retrieves all the registered libraries.
 * @public
 * @returns Map with all registered libraries
 */
export function getLibraries() {
    const result = trGetLibraries();
    return result.reduce((acc, curr) => {
        acc.set(curr.name, curr);
        return acc;
    }, new Map());
}
/**
 * Retrieves a single registered library based on the name of it.
 * @public
 * @param name - Name of the library
 * @returns Registered library or undefined if the library is not registered
 */
export function getLibrary(name) {
    return trGetLibrary(name);
}
